/* eslint no-console: 0 */
import logger from './logger';
import { logLevels, logEvents } from '../constants/appConstants';

const config = _CONFIG_;

/**
* @desc Log errors & events in the log file saved on disk
* by passing the error & events info to the Spotlight Client logging method
* 'logLevel' param can be 'Information' or 'Warning'
*/


const logMessage = (logLevel, message) => {
    if (logLevels.LEVELS.indexOf(config.logLevel) >= logLevels.LEVELS.indexOf(logLevel)) {
        if (isExternalMethodImplemented('WriteLog')) {
            window.external.WriteLog(logLevel, JSON.stringify(message));
        } else {
            console.debug('[DEBUG LOG]', message);
        }
    }
};

const acpGet = (path, callback) => {
    try {
        if (isExternalMethodImplemented('AcpGet')) {
            window.external.AcpGet('backend', path, callback);
        } else {
            console.debug('[DEBUG LOG]', 'acpGet not found in window.external please use apiCall service instead');
        }
    } catch (err) {
        handleErrorHelper('AcpGet error', err);
    }
};

const closeHtml  = (reason) => {
    try {
        if (isExternalMethodImplemented('CloseHtml')) {
            window.external.CloseHtml(reason);
        } else {
            console.debug('[DEBUG LOG] window.external.closeHtml not found');
        }
    } catch (err) {
        handleErrorHelper('CloseHtml error', err);
    }
};

const setTitlebarVisibility = (reason) => {
    try {
        if (isExternalMethodImplemented('SetTitlebarVisibility')) {
            window.external.SetTitlebarVisibility(reason);
        } else {
            console.debug('[DEBUG LOG] window.external.SetTitlebarVisibility not found');
        }
    } catch (err) {
        handleErrorHelper('SetTitlebarVisibility error', err);
    }
};

const htmlError = (reason) => {
    try {
        if (isExternalMethodImplemented('HtmlError')) {
            window.external.HtmlError(reason);
        } else {
            console.debug('[DEBUG LOG] window.external.HtmlError not found');
        }
    } catch (err) {
        handleErrorHelper('HtmlError error', err);
    }
};

const sendMixpanelEvent = (eventName, data) => {
    try {
        if (isExternalMethodImplemented('SendMixpanelEvent')) {
            logger(logLevels.DEBUG, {source: 'externalMethods.sendMixpanelEvent', action: logEvents.EXTERNAL_EVENT_CALLED, payload: {eventName, data}});
            window.external.SendMixpanelEvent(eventName, JSON.stringify(data));
        } else {
            console.debug('[DEBUG LOG] SEND MIXPANEL: ', eventName, data);
        }
    } catch (err) {
        handleErrorHelper('SendMixpanelEvent error', err);
    }
};

const subscribeToEvents = (callback) => {
    try {
        if (isExternalMethodImplemented('SubscribeToEvents')) {
            window.external.SubscribeToEvents(callback);
        } else {
            // fallback for local testing purposes
            setTimeout(callback('{"type": "TriggerAnimation"}'), 0);
        }
    } catch (err) {
        handleErrorHelper('SubscribeToEvents error', err);
    }
};

const openUrl = (url) => {
    try {
        if (isExternalMethodImplemented('OpenUrl')) {
            logger(logLevels.DEBUG, {source: 'externalMethods.OpenUrl', action: logEvents.EXTERNAL_EVENT_CALLED, payload: {url}});
            window.external.OpenUrl(url);
        } else {
            window.open(url, '_blank');
        }
    } catch (err) {
        handleErrorHelper('OpenUrl error', err);
    }
};

const openPlansPage = (url) => {
    try {
        if (isExternalMethodImplemented('OpenPlansPage')) {
            logger(logLevels.DEBUG, {source: 'externalMethods.OpenPlansPage', action: logEvents.EXTERNAL_EVENT_CALLED, payload: {url}});
            window.external.OpenPlansPage(url);
        } else {
            window.open(url, '_blank');
            console.debug('[DEBUG LOG]', 'OpenPlansPage not found in window.external');
        }
    } catch (err) {
        handleErrorHelper('OpenPlansPage error', err);
    }
};

const isFeatureEnabled = (feature) => {
    try {
        if (isExternalMethodImplemented('IsFeatureEnabled')) {
            logger(logLevels.DEBUG, {source: 'externalMethods.isFeatureEnabled', action: logEvents.EXTERNAL_EVENT_CALLED, payload: {feature}});
            return window.external.IsFeatureEnabled(feature);
        }
        console.debug('[DEBUG LOG] IsFeatureEnabled not found in window.external');
        return false;
    } catch (err) {
        handleErrorHelper('IsFeatureEnabled error', err);
        return false;
    }
};

const acpPost = (path, payload, callback) => {
    try {
        if (isExternalMethodImplemented('AcpBackendPost')) {
            const stringPayload = JSON.stringify(payload);
            window.external.AcpBackendPost(path, stringPayload, callback);
        } else {
            console.debug('[DEBUG LOG]', 'AcpBackendPost not found in window.external please use apiPost service instead');
        }
    } catch (err) {
        handleErrorHelper('AcpBackendPost error', err);
    }
};

const acpSubscribe = (path, callback) => {
    try {
        if (isExternalMethodImplemented('AcpSubscribe')) {
            window.external.AcpSubscribe('backend', path, callback);
        } else {
            console.debug('[DEBUG LOG]', 'acpSubscribe not found in window.external');
        }
    } catch (err) {
        handleErrorHelper('AcpSubscribe error', err);
    }
};

const setConfiguration  = (key, value) => {
    try {
        if (isExternalMethodImplemented('SetConfiguration')) {
            logger(logLevels.DEBUG, {source: 'externalMethods.setConfiguration', action: logEvents.EXTERNAL_EVENT_CALLED, payload: {key, value}});
            window.external.SetConfiguration(key, value);
        } else {
            console.debug('[DEBUG LOG] window.external.SetConfiguration not found');
        }
    } catch (err) {
        handleErrorHelper('SetConfiguration error', err);
    }
};

const fetchSmartScanResults = (callback) => {
    try {
        if (isExternalMethodImplemented('FetchSmartScanResults')) {
            window.external.FetchSmartScanResults(callback);
        } else {
            console.debug('[DEBUG LOG] window.external.FetchSmartScanResults not found');
        }
    } catch (err) {
        handleErrorHelper('FetchSmartScanResults error', err);
    }
};

const isExternalMethodImplemented = (method) => {
    if (window.external && (method in window.external)) {
        return true;
    }
    return false;
};

const handleErrorHelper = (msg, err) => {
    logMessage(logLevels.WARNING, {
        Message: msg,
        Exception: (err instanceof Error) ? err.toString() : `${JSON.stringify(err)}`,
    });
};

export {
    logMessage,
    acpGet,
    closeHtml,
    setTitlebarVisibility,
    htmlError,
    isExternalMethodImplemented,
    isFeatureEnabled,
    sendMixpanelEvent,
    subscribeToEvents,
    openUrl,
    acpPost,
    acpSubscribe,
    setConfiguration,
    fetchSmartScanResults,
    openPlansPage,
};
